// extracted by mini-css-extract-plugin
export default {"ProjectsList":"ProjectsList_ProjectsList__3f5s+","Container":"ProjectsList_Container__WjjPq"};